<template>
  <div>
    <!--Header-->
    <div class="header bg-gradient-orange py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="pr-5">
                <h1 class="display-2 text-white font-weight-bold mb-0">
                  Become an Affiliate!
                </h1>
                <h2 class="h2 text-white font-weight-light">
                  With ChinesePod’s affiliate program, you make money even if
                  the subscribers don’t pay<a
                    class="font-weight-bold"
                    href="#footnote"
                    title="Footnote"
                    >*</a
                  >.
                </h2>

                <div class="mt-5">
                  <div>
                    <router-link
                      v-if="!isEnrolled && !isTeam"
                      :to="{ name: 'Register' }"
                      class="btn btn-neutral my-2"
                      >Sign Up Now <i class="fas fa-arrow-right" />
                    </router-link>
                    <router-link
                      v-else
                      :to="{ name: 'Dashboard' }"
                      class="btn btn-neutral my-2"
                      >To Dashboard <i class="fas fa-arrow-right"
                    /></router-link>
                  </div>
                  <div>
                    <base-button
                      class="btn btn-neutral my-2"
                      @click="modal = 'faqModal'"
                      >FAQ <i class="fas fa-info-circle"
                    /></base-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row pt-5">
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-body">
                      <div
                        class="icon icon-shape bg-gradient-red text-white rounded-circle shadow mb-4"
                      >
                        <i class="ni ni-active-40"></i>
                      </div>
                      <h5 class="h3">4000+ Lessons</h5>
                      <p>
                        ChinesePod offers one of the largest online material
                        libraries with over 4000 lessons.
                      </p>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-body">
                      <div
                        class="icon icon-shape bg-gradient-info text-white rounded-circle shadow mb-4"
                      >
                        <i class="ni ni-active-40"></i>
                      </div>
                      <h5 class="h3">Recordings & Transcripts</h5>
                      <p>
                        Our lessons come with vocabulary and dialogue sections
                        and transcripts.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 pt-lg-5 pt-4">
                  <div class="card mb-4">
                    <div class="card-body">
                      <div
                        class="icon icon-shape bg-gradient-success text-white rounded-circle shadow mb-4"
                      >
                        <i class="ni ni-active-40"></i>
                      </div>
                      <h5 class="h3">Video & Audio</h5>
                      <p>
                        ChinesePod offers both video and audio lessons. Whether
                        you're on the move or at your computer - keep learning!
                      </p>
                    </div>
                  </div>
                  <div class="card mb-4">
                    <div class="card-body">
                      <div
                        class="icon icon-shape bg-gradient-warning text-white rounded-circle shadow mb-4"
                      >
                        <i class="ni ni-active-40"></i>
                      </div>
                      <h5 class="h3">Vocabulary & SRS</h5>
                      <p>
                        You will find lesson vocabulary and spaced repetition
                        algorithm ready for use.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <section class="py-6 bg-default">
      <div class="row justify-content-center">
        <div class="col-lg-8 text-center">
          <h2 class="display-4 text-white">
            BECOME AN AFFILIATE IN JUST A FEW CLICKS
          </h2>
          <div class="mt-5">
            <router-link
              v-if="!isEnrolled && !isTeam"
              :to="{ name: 'Register' }"
              class="btn btn-primary my-2"
              >Sign Up Now <i class="fas fa-arrow-right" />
            </router-link>
            <router-link
              v-else
              :to="{ name: 'Dashboard' }"
              class="btn btn-primary my-2"
              >To Dashboard <i class="fas fa-arrow-right"
            /></router-link>
          </div>
        </div>
      </div>
      <div id="footnote" class="row justify-content-center text-center">
        <div class="col-md-6 pt-8">
          <p class="text-white">
            * Subscriber needs to register and confirm their account within a 14
            day period.
          </p>
        </div>
      </div>
    </section>
    <modal :show="modal === 'faqModal'" @close="modal = ''">
      <div slot="header">
        <h2 class="">Frequently Asked Questions</h2>
      </div>
      <div class="modal-body">
        <div class="h3">What is the Chinesepod Affiliate program?</div>
        <p>
          The Affiliate program is a way for you to become part of the team! By
          signing up members, both free and paid, you will get paid directly by
          us.
        </p>
        <div class="h3">How does the Chinesepod Affiliate program work?</div>
        <p>
          Once you are signed up, you will receive information on how to verify
          your sign ups. By sharing this information with your followers, we
          will be able to link their sign ups directly to you and credit you.
        </p>
        <div class="h3">How much do I get paid?</div>
        <p>
          For qualifying memberships, you will receive $10 for paid and 50 cents
          for free sign ups.
        </p>
        <div class="h3">How often can I share the code?</div>
        <p>
          Be your own boss. Share your code as many times as you want with your
          followers. Just one evergreen podcast or YouTube video can
          continuously generate funds for you and your team.
        </p>
      </div>
    </modal>
  </div>
</template>
<script>
import { Tooltip } from 'element-ui'
import { mapGetters } from 'vuex'

export default {
  title() {
    return `ChinesePod Affiliates`
  },
  name: 'home-page',
  components: {
    [Tooltip.name]: Tooltip
  },
  computed: {
    ...mapGetters('affiliates', ['isEnrolled', 'isTeam'])
  },
  data() {
    return {
      modal: ''
    }
  }
}
</script>
